// Components
import { useEffect } from 'react';
import { AltDesignationsCard } from 'components/AltDesignationsCard/AltDesignationsCard';
// Slices
import { fetchLanguages } from 'slices/language.slice';
import { useAppDispatch } from 'slices/store';
import { TEDrawerSection } from '@timeedit/ui-components';

type tProps = {
  value?: any;
  onChangeValue: (type: string, value: any) => void;
};
export const Language = ({ value, onChangeValue }: tProps) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(fetchLanguages());
  }, [dispatch]);
  return (
    <TEDrawerSection label="Language">
      <div className="section-item">
        <AltDesignationsCard
          title="Display name"
          displayDescription
          altDesignations={value.altDesignations || []}
          onChange={(newAltDesignations) =>
            onChangeValue('altDesignations', newAltDesignations)
          }
        />
      </div>
    </TEDrawerSection>
  );
};
